import { render, staticRenderFns } from "./update-approve.vue?vue&type=template&id=2a37219e&scoped=true&"
import script from "./update-approve.vue?vue&type=script&lang=js&"
export * from "./update-approve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a37219e",
  null
  
)

export default component.exports